export default "__VITE_ASSET__BJjCwfpw__"